import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {StrategiesDataStoreService} from '../../shared/services/strategies-data-store.service';


@Injectable()
export class StrategyService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient,
              private _strtDataStore: StrategiesDataStoreService) { }

  updatePurpose(strategyId: number, purpose: string): Observable<{}> {
    return this.http.put(`${this.baseUrl}/strategies/${strategyId}/purpose`, purpose);
  }

  updateMission(strategyId: number, mission: string): Observable<{}> {
    return this.http.put(`${this.baseUrl}/strategies/${strategyId}/mission`, mission);
  }

  updateBeliefs(strategyId: number, beliefs: string): Observable<{}> {
    return this.http.put(`${this.baseUrl}/strategies/${strategyId}/beliefs`, beliefs);
  }

  isPreventDeliverablePrompt(strategyId: number): Observable<boolean> {
    return this.http.get(`${this.baseUrl}/strategies/${strategyId}/deliverableprompt`)
      .pipe(map(it => !it['canShowDeliverablePrompt']));
  }

  setPreventDeliverablePrompt(strategyId: number): Observable<{}> {
    return this.http.put(`${this.baseUrl}/strategies/${strategyId}/preventdeliverableprompt`, {});
  }

  /**
   * Will fetch the impact statemnt for the plan
   * Sets the impact statment in the data store
   *  - Any downstream observers will auto update
   * @param {number} strategyId
   */
  getImpact(strategyId: number): void {
    this.http.get(`${this.baseUrl}/strategies/${strategyId}/impacttext`)
      .pipe(map((it: {impactText: string}) => it.impactText)).subscribe((impactStmt: string) => {
        this._strtDataStore.impactStatement = impactStmt;
    }, (err) => {
        console.error(`Error getting impact statement: `, err);
    });
  }

  /**
   * Will update an impact statemnt for the plan
   * Returns a empty JSON object
   * @param {number} strategyId
   * @param {string} impact
   * @returns {Observable<{}>}
   */
  updateImpact(strategyId: number, impact: string): Observable<{}> {
    return this.http.put(`${this.baseUrl}/strategies/${strategyId}/impacttext`, impact);
  }
}
